export default "__VITE_ASSET__Cy2PifBh__"